import React, { useEffect, useState, useRef } from 'react';
import { observer, inject } from 'mobx-react';

import CharityDetailsModal from 'components/modals/CharityDetailsModal';

import withUserContext from 'behaviors/withUserContext';
import { EventListWithArrowsAbove } from 'components/EventList/EventList';
import useLocalFeedStore from 'stores/LocalFeedStore';

import { EmployeeMatchSection, SearchNonprofitsSection } from './components';
import useDashboardStore from 'stores/DashboardStore';
import useSearchStore from 'stores/SearchStoreV2';

const DiscoverView = ({
  activeEntity,
  uiStore,
  donationLandingStore,
  userProfileStore,
  authStore,
  companyStore,
}) => {
  const feedSectionRef = useRef(null);
  const searchStore = useSearchStore();

  const userId =
    activeEntity?.userContext?.userId ||
    activeEntity?.userContext?.influencerId;

  const user = userProfileStore.users.get(+userId);
  const { getLocalNonprofits, getParsedLocation } = useLocalFeedStore();

  const { setProps } = useDashboardStore();

  const [detailCharity, setDetailCharity] = useState(null);
  const [showDetails, setShowDetails] = useState(false);
  const [zipCode, setZipCode] = useState(user?.zip);

  useEffect(() => {
    Promise.all(
      zipCode
        ? [
            getParsedLocation({ location: zipCode }),
            getLocalNonprofits({ location: zipCode }),
          ]
        : [],
    );
  }, [zipCode, getLocalNonprofits]);

  useEffect(() => {
    setZipCode(user?.zip);
  }, [user]);

  useEffect(() => {
    if (!activeEntity) return;

    setProps({
      size: 'half',
      title: 'Altman Team',
    });
    userProfileStore.getUser({
      id: activeEntity.id,
      userContext: activeEntity.userContext,
      checkCache: false,
    });

    userProfileStore.getCompanyMatch({ id: activeEntity.id });
  }, [activeEntity]);

  useEffect(() => {
    searchStore.getTopics();
    searchStore.getCategories();
  }, []);

  useEffect(() => {
    if (searchStore.matchCompanyId && searchStore.topics.length > 0) {
      searchStore.getTopicEvents();
    }
  }, [searchStore.matchCompanyId, searchStore.topics]);

  return (
    <div className="search-view flex-column">
      <div className="mb-5">
        {showDetails && (
          <CharityDetailsModal
            isOpen={showDetails}
            mini
            onToggleClose={() => {
              setShowDetails(false);
              setDetailCharity(null);
            }}
            charity={detailCharity}
          />
        )}

        <EmployeeMatchSection match={userProfileStore.companyMatch} />

        <EventListWithArrowsAbove
          title="Match Eligible Cauzes"
          events={searchStore.topicEvents}
          loading={searchStore.loadingTopicEvents}
          uiStore={uiStore}
          className="mt-8"
        />

        <div ref={feedSectionRef} className="h-0 w-0"></div>

        <SearchNonprofitsSection
          activeEntity={activeEntity}
          uiStore={uiStore}
          authStore={authStore}
        />
      </div>
    </div>
  );
};

export default withUserContext(
  inject(
    'donationLandingStore',
    'uiStore',
    'authStore',
    'charityStore',
    'localFeedStore',
    'userProfileStore',
    'profileStore',
    'companyStore',
  )(observer(DiscoverView)),
);
